import AccountBadge from '@/features/openTabs/components/AccountBadge'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface SplitHeaderProps {
    accountName: string
    accountNumber: number
}

const SplitHeader: FC<SplitHeaderProps> = ({ accountName, accountNumber }) => {
    const { t } = useTranslation('app')
    const { styles } = useStyles(stylesheet)

    return (
        <View style={styles.container}>
            <Typography.Heading variant="h3" style={styles.title}>
                {t('openTabs.split.title')} | {accountName}
            </Typography.Heading>
            <AccountBadge number={accountNumber} variant="compact" />
        </View>
    )
}

const stylesheet = createStyleSheet({
    title: {
        flexShrink: 1,
        minWidth: 0,
    },
    container: {
        minHeight: 26,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        paddingHorizontal: 16,
    },
})

export default SplitHeader
